import { HsBox } from '../../../math-new/shapes/box.class';
import { HsSphere } from '../../../math-new/shapes/sphere.class';
import { HsObject3D } from './object-3d.class';

export abstract class HsEngineObject extends HsObject3D {
  public boundingBox: HsBox = HsBox.makeEmpty();
  public boundingSphere: HsSphere = HsSphere.makeEmpty();
}
